var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0119 2.98816C16.361 2.33728 15.3057 2.33728 14.6548 2.98816L7.50001 10.143L7.50001 12.5H9.85703L17.0119 5.34518C17.6627 4.6943 17.6627 3.63903 17.0119 2.98816Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16668 4.16667H5.00001C4.07954 4.16667 3.33334 4.91286 3.33334 5.83334V15C3.33334 15.9205 4.07954 16.6667 5.00001 16.6667H14.1667C15.0872 16.6667 15.8333 15.9205 15.8333 15V10.8333M14.6548 2.98816C15.3057 2.33728 16.361 2.33728 17.0119 2.98816C17.6627 3.63903 17.6627 4.6943 17.0119 5.34518L9.85703 12.5H7.50001L7.50001 10.143L14.6548 2.98816Z",
    stroke: "#6366F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilAlt);
export default __webpack_public_path__ + "static/media/PencilAlt.96dbb4a69ad6ca8ec54bec7ee3a5a156.svg";
export { ForwardRef as ReactComponent };